import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { instanceRef } from '../../../utils/axios';

export default function ProductosSelect(props) {
  const [productos, setProductos] = useState();
  const { Option } = Select;

  const fetchListProductos = async (searchText) => {
    if (props.aseguradora) {
      const response = await instanceRef.instance.get(
        `/aseguradoraproducto/activelist/${props.aseguradora}`,
        {
          params: {
            current: 1,
            pageSize: 10,
            filters: {
              descripcion: searchText
            }
          }
        }
      );
      setProductos(response.data.data.rows);
    } else {
      const response = await instanceRef.instance.get(`/productos/all`, {
        params: {
          current: 1,
          pageSize: 10,
          filters: {
            descripcion: searchText
          }
        }
      });
      setProductos(response.data.data);
    }
  };

  function handleChange(value) {
    props.getProductoId(value);
  }

  useEffect(() => {
    fetchListProductos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {productos && (
        <Select
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          style={{ width: 'auto' }}
          dropdownStyle={{ minWidth: '190px' }}
          optionFilterProp="children"
          placeholder="Seleccionar Producto"
          onChange={handleChange}
        >
          {productos.map((item) => (
            <Option key={item.codigo} value={`${item.id}`}>
              {`${item.descripcion}`}
            </Option>
          ))}
        </Select>
      )}
    </>
  );
}
